import { z } from 'zod';
export const insuranceClaimsDocumentsScopeCompletionCapability = 'documents.insurance-claim-scope-completion.v1';
export const insuranceClaimsDocumentsScopeCompletionSlot = 'insurance-claims.scope-completion';
export const insuranceClaimsDocumentsScopeCompletionProviderId = 'documents.server.insurance-claims-scope-completion';
const idSchema = z.string().uuid();
const sha256Schema = z.string().regex(/^[a-f0-9]{64}$/);
const documentStatusSchema = z.enum([
    'draft', 'sent', 'viewed', 'signed', 'declined', 'voided', 'expired',
]);
export const insuranceClaimsDocumentsScopeCompletionProviderRequestSchema = z.strictObject({
    consumerModuleId: z.literal('insurance-claims'),
    requestedCapability: z.literal(insuranceClaimsDocumentsScopeCompletionCapability),
    resourceType: z.literal('insurance-claims.scope'),
    resourceId: idSchema,
    claimId: idSchema,
    projectId: idSchema,
});
const signatureSchema = z.discriminatedUnion('state', [
    z.strictObject({ state: z.literal('missing') }),
    z.strictObject({
        state: z.literal('present'), signatureId: idSchema, signatureSha256: sha256Schema,
        signedAt: z.string().datetime({ offset: true }),
    }),
]);
const artifactSchema = z.discriminatedUnion('state', [
    z.strictObject({ state: z.literal('missing') }),
    z.strictObject({
        state: z.literal('present'), objectId: idSchema,
        contentType: z.string().trim().min(1).max(255),
        sizeBytes: z.number().int().positive().safe(), sha256: sha256Schema,
        verifiedAt: z.string().datetime({ offset: true }),
        attachedAt: z.string().datetime({ offset: true }),
    }),
]);
export const insuranceClaimsDocumentsScopeCompletionFactSchema = z.strictObject({
    capability: z.literal(insuranceClaimsDocumentsScopeCompletionCapability),
    claimId: idSchema,
    projectId: idSchema,
    scopeId: idSchema,
    instanceId: idSchema,
    sourceVersion: z.number().int().positive(),
    contentHash: sha256Schema,
    status: documentStatusSchema,
    signature: signatureSchema,
    artifact: artifactSchema,
    observedAt: z.string().datetime({ offset: true }),
});
export const insuranceClaimsDocumentsScopeCompletionProviderResponseSchema = z.strictObject({
    state: z.literal('present'),
    capability: z.literal(insuranceClaimsDocumentsScopeCompletionCapability),
    claimId: idSchema,
    projectId: idSchema,
    scopeId: idSchema,
    facts: z.array(insuranceClaimsDocumentsScopeCompletionFactSchema).max(500),
}).superRefine((value, context) => {
    const instanceIds = value.facts.map(({ instanceId }) => instanceId);
    if (new Set(instanceIds).size !== instanceIds.length) {
        context.addIssue({ code: 'custom', path: ['facts'], message: 'Document facts must be unique.' });
    }
    value.facts.forEach((fact, index) => {
        if (fact.claimId !== value.claimId || fact.projectId !== value.projectId ||
            fact.scopeId !== value.scopeId) {
            context.addIssue({
                code: 'custom', path: ['facts', index],
                message: 'Document facts must match the requested Claim, Project, and scope.',
            });
        }
    });
});
export const insuranceClaimsScopeOwnerUnavailableReasonSchema = z.enum([
    'not-installed', 'not-enabled', 'permission-denied', 'provider-invalid', 'provider-failed',
]);
export const insuranceClaimsDocumentsScopeCompletionAvailabilitySchema = z.discriminatedUnion('state', [
    insuranceClaimsDocumentsScopeCompletionProviderResponseSchema,
    z.strictObject({
        state: z.literal('unavailable'),
        capability: z.literal(insuranceClaimsDocumentsScopeCompletionCapability),
        reasonCode: insuranceClaimsScopeOwnerUnavailableReasonSchema,
    }),
]);
//# sourceMappingURL=insurance-claims-documents-scope-completion.contract.js.map